import React from 'react'
import PropTypes from 'prop-types'
import ContentLoader from 'react-content-loader'
import { connect } from 'react-redux'
import { bem } from '@argos/utils'

import { Spinner } from '../../../Common'

const cn = bem({ prefix: 'lc-', block: 'waiting-room' })

export class WaitingRoom extends React.Component {
  static propTypes = {
    estimatedWaitTime: PropTypes.number,
    waitMessage: PropTypes.string,
  }

  get formattedWaitTime() {
    return this.props.estimatedWaitTime < 1 ? 1 : Math.ceil(this.props.estimatedWaitTime / 60)
  }

  get durationSuffix() {
    return this.formattedWaitTime === 1 ? 'minute' : 'minutes'
  }

  render() {
    const { waitMessage, estimatedWaitTime } = this.props

    const SkeletonBar = (props) => (
      <ContentLoader height={5} width={70} speed={1.5} primaryColor='#f5f5f5' secondaryColor='#fcfcfc' {...props}>
        <rect x='0' y='0' rx='1' ry='1' height='5' width='70' />
      </ContentLoader>
    )

    return (
      <div className={`${cn()} lc-controls__form lc-controls__form--with-seperator text-center`}>
        <div role='alert' className={cn('wrapper', 'narrow')}>
          {waitMessage || <SkeletonBar className={cn('message-placeholder')} />}
          <Spinner className={cn('spinner')} />
          {estimatedWaitTime ? (
            <h3 role='alert' className={cn('eta')}>
              You're up in about {this.formattedWaitTime} {this.durationSuffix}
            </h3>
          ) : (
            <SkeletonBar className={cn('message-placeholder')} />
          )}
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({
  estimatedWaitTime: state.Chat.estimatedWaitTime,
  waitMessage: state.Chat.waitMessage,
})

export default connect(mapStateToProps)(WaitingRoom)
